import { useState } from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router";
import { CalendarDays, MapPin, Menu, Phone, X } from "lucide-react";
import { EASE, LOGO_IMAGE } from "./data";

export function Navbar({ scrollTo, onBook, hasGallery = true, hasPosts = false }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const navigate = useNavigate();
  const go = (id) => { scrollTo(id); setMenuOpen(false); };
  const goPosts = () => { navigate("/posts"); setMenuOpen(false); };
  return (
    <>
      <div className="topline"><div className="container top-inner"><span><MapPin size={14} /> Medicover Hitec City · LUX Gachibowli</span><a data-testid="top-phone-link" href="tel:7780793371"><Phone size={14} /> 7780793371</a></div></div>
      <motion.header className="nav container" initial={{ y: -18, opacity: 0 }} animate={{ y: 0, opacity: 1 }} transition={{ duration: 0.8, ease: EASE }}>
        <button className="brand" data-testid="brand-home-button" onClick={() => go("home")}><img className="brand-logo" data-testid="nav-logo" src={LOGO_IMAGE} alt="Dr. Sreeniketh Reddy — Urologist, Andrologist and Robotic Surgeon" /></button>
        <button className="menu-button" data-testid="mobile-menu-button" onClick={() => setMenuOpen(!menuOpen)}>{menuOpen ? <X /> : <Menu />}</button>
        <nav className={menuOpen ? "nav-links open" : "nav-links"}>
          <button data-testid="nav-about-link" onClick={() => go("about")}>About</button>
          <button data-testid="nav-specialties-link" onClick={() => go("specialties")}>Specialties</button>
          <button data-testid="nav-articles-link" onClick={() => go("articles")}>Common Symptoms</button>
          {hasPosts && <button data-testid="nav-posts-link" onClick={goPosts}>Posts</button>}
          {hasGallery && <button data-testid="nav-gallery-link" onClick={() => go("gallery")}>Gallery</button>}
          <button data-testid="nav-faq-link" onClick={() => go("faq")}>FAQs</button>
          <button className="button button-outline nav-cta" data-testid="nav-appointment-button" onClick={onBook}><CalendarDays size={16} /> Request an appointment</button>
        </nav>
      </motion.header>
    </>
  );
}
